import { createContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { getDefaultMetricDisplay } from "helpers/metrics"
import { usePreferences } from "hooks/use-preferences"

const PREFERENCE_SUBTYPE = "asset-view-exposure"
const PREFERENCE_FIELDS = [
  "selectedCategory",
  "selectedMetricDisplay",
]

const DEFAULT_STATE = {
  selectedCategory: "style",
  selectedMetricDisplay: getDefaultMetricDisplay("exposure"),
}

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setSelectedCategory":
        draft.selectedCategory = action.selectedCategory
        break
      case "setSelectedMetricDisplay":
        draft.selectedMetricDisplay = action.selectedMetricDisplay
        break
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
    }
  })
}

function setPreferences(preferences) {
  return { type: "setPreferences", preferences }
}

export const EXPOSURE_CONTEXT = createContext()

export default function ExposureContext({ children }) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)

  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setSelectedCategory: (selectedCategory) => dispatch({ type: "setSelectedCategory", selectedCategory }),
    setSelectedMetricDisplay: (selectedMetricDisplay) => dispatch({ type: "setSelectedMetricDisplay", selectedMetricDisplay }),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return <EXPOSURE_CONTEXT.Provider value={contextValue}>
    {children}
  </EXPOSURE_CONTEXT.Provider>
}
